// In framework/client/widgets/AIUsageMonitorWidget.widget.js

export default {
    name: "AIUsageMonitorWidget",
    type: "ChartWidget",
    description: "Displays AI model usage and estimated costs.",
    roles: ["admin"],
    widget: {
        title: "AI Usage & Cost",
        size: "large",
        dataProvider: {
            main: {
                rpc: "AdminAnalyticsRpc.getUsageData",
                params: {
                    groupBy: "model",
                }
            }
        },

        chartType: "bar",
        labelsField: "model", 
        dataField: "totalCost",
        datasetOptions: {
            label: "Estimated Cost ($)",
            backgroundColor: [
                'rgba(255, 99, 132, 0.7)', 'rgba(54, 162, 235, 0.7)', 'rgba(255, 206, 86, 0.7)',
                'rgba(75, 192, 192, 0.7)', 'rgba(153, 102, 255, 0.7)', 'rgba(255, 159, 64, 0.7)'
            ],
            borderColor: [
                'rgba(255, 99, 132, 1)', 'rgba(54, 162, 235, 1)', 'rgba(255, 206, 86, 1)',
                'rgba(75, 192, 192, 1)', 'rgba(153, 102, 255, 1)', 'rgba(255, 159, 64, 1)'
            ],
            borderWidth: 1
        },
        options: {
            responsive: true,
            maintainAspectRatio: false,
            scales: {
                y: {
                    beginAtZero: true,
                    ticks: { callback: function(value) { return '$' + value.toFixed(2); } }
                }
            },
            plugins: {
                legend: { display: true, position: 'top' },
                title: { display: true, text: 'AI Usage Cost by Model' }
            }
        },
    }
};